module.exports = __webpack_public_path__ + "static/dsc-0496@2x-c27a9081a2d713c5685afebdc2aa89e0.png";